import React, { useEffect, useState } from "react";
import "./RunQuickAction.css";
import { Button, Card, Drawer, Switch, Tooltip, message } from "antd";
import { PiBookOpenText } from "react-icons/pi";
import {
  MdInfoOutline,
  MdKeyboardBackspace,
  MdOutlineRemoveRedEye,
} from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { FaRegFileAlt } from "react-icons/fa";
import { RiEditBoxFill, RiFileUploadFill } from "react-icons/ri";
import QuickBatchDrawer from "./QuickBatchDrawer/QuickBatchDrawer";
import UploadComputerData from "./UploadComputerData/UploadComputerData";
import UploadOwnData from "./UploadOwnData/UploadOwnData";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BuildQuickActionByIdActionHandler } from "../../../Redux/Actions/user/BuildQuickActionDetailsById";
import QuickSearchRun from "./QuickSearchRun/QuickSearchRun";
import {
  quick_Action_Run_Upload_File_With_FileidHandler,
  quick_Action_Run_Upload_File_With_Fileid_Success,
} from "../../../Redux/Actions/user/RunQuickActionUploadFilewithFileId";
import { run_Quick_Action_Run_IdActionHandler } from "../../../Redux/Actions/user/RunQuickActionRunId";
import Loader from "../../../Components/Loader/Loader";
import {
  quick_Action_Run_Status_ActionHandler,
  quick_Action_Run_Status_Success,
} from "../../../Redux/Actions/user/RunQuickActionStatus";
import { Run_Quick_Action_Run_Id_Success } from "../../../Redux/Actions/user/RunQuickActionRunId";
import Swal from "sweetalert2";
import { quick_Action_Run_Save_Execute_Batch_Success } from "../../../Redux/Actions/user/RunQuickActionSaveExecuteBatch";
import { quick_Action_Run_Generate_Chunks_Success } from "../../../Redux/Actions/user/RunQuickActionGenerateChunks";
import ReferencedataShow from "./ReferencedataShow/ReferencedataShow";
import { CiCircleInfo } from "react-icons/ci";

const blackLock = "/assets/black-lock.svg";
const SideClose = "/assets/ModalClose.svg";

const RunQuickAction = () => {
  const Navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [isDragging, setIsDragging] = useState(false);
  const [isBatchOpen, setIsBatchOpen] = useState(false);
  const [isUploadOutComputer, setIsUploadOutComputer] = useState(false);
  const [isOwnOutData, setIsOwnOutData] = useState(false);
  const [showQuickSearch, setShowQuickSearch] = useState(false);
  const [ViewResult, setViewResult] = useState("");
  const [SupportDocumentId, setSupportDocumentId] = useState(null);
  const [datauploadComputer, setUploadComputerData] = useState([]);
  const [getFileType, setGetFileType] = useState("");
  const [textAreaData, setTextAreaData] = useState("");
  const [QuickActionRunStatus, setQuickRunStatus] = useState(null);
  const [accessLevel, setAccessLevel] = useState("");
  const [runStatusMainData, setRunStatusMainData] = useState("");
  const [uploadDatarunAgain, setuploadDatarunAgain] = useState([]);
  const [BatchProcessing, setBatchProcessing] = useState("");
  const [UploadEditData, setUploadEditData] = useState("");
  const [QuickSaveExecuteResponse, setQuickSaveExecuteResponse] = useState("");
  const [statusLoader, setStatusLoader] = useState(false);
  const [EditSummary, setEditSummary] = useState(false);
  const [isEditQuickBatch, setisEditQuickBatch] = useState(false);
  const [showCheckbox, setShowCheckbox] = useState(true);
  const [batchSizeBox, setBatchSizeBox] = useState("");
  const [batchKeywordbox, setBatchKeyWordbox] = useState("");
  const [Summararizebatchbox, setSummararizebatchbox] = useState(true);
  const [saveExecuteStaushandle, setSaveExecuteStatushandle] = useState(false);
  const [openRunStatus, setOpenRunStatus] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [tableFlutuationOff, setTableFlutuationOff] = useState(false);
  const [loaderwill, setLoaderwill] = useState(false);
  const [fileLoader, setFileLoader] = useState(false);
  const [DragDropfile, setDragDropfile] = useState("");
  const [showOutput, setShowOutput] = useState(false);
  const [privateData, setPrivateData] = useState(false);
  const [isActionBtnDisabled, setIsActionBtnDisabled] = useState(true);
  const [continuesLoader, setcontinuesLoader] = useState(false);
  // const [handleOpen, sethandleOpen] = useState(false);
  const [editOutputData, seteditOutputData] = useState([]);
  const [isListOutputData, setIsListOutputData] = useState(false);
  const [text, setText] = useState("");

  const [IsBatchOnLargeData, setIsBatchOnLargeData] = useState(false);
  const [coutingFiles, setCoutingFiles] = useState(0);

  // const handleAccessLevelChange = (event) => {
  //   setAccessLevel(event.target.value);
  // };

  const QauserData = useSelector(
    (state) => state.SettingsUserProfileData?.user_profile_data
  );

  const tooltipContent = (
    <div className="remove-tooltip-space">
      <p>
        The output will only be visible to you. Account and workspace members
        will not see the output.
      </p>
    </div>
  );
  const handleAccessLevelChange = (newValue) => {
    setAccessLevel(newValue ? "ON" : "OFF");
  };

  const buildQuickActionDetaills = useSelector(
    (state) =>
      state?.build_Quick_Action_By_Id_data?.build_quick_action_by_id__data?.data
  );

  const uploadFilebyidAgain = useSelector(
    (state) =>
      state?.quick_Action_Run_Upload_With_Fielid_Data
        ?.quick_Action_Run_Upload_With_Fielid_data?.data
  );

  const quickrunData = useSelector(
    (state) =>
      state?.run_Quick_Action_Run_Id_Data?.run_Quick_Action_Run_Id_data?.data
  );

  const quickrunStatusData = useSelector(
    (state) =>
      state?.quick_Action_Run_Status_Data?.quick_Action_Run_Status_data?.data
  );

  const quickrunStatusDataLoader = useSelector(
    (state) => state?.quick_Action_Run_Status_Data?.loader
  );

  useEffect(() => {
    if (params?.id) {
      setPageLoader(true);
      dispatch(BuildQuickActionByIdActionHandler(params?.id));
    }

    return () => {
      setBatchProcessing("");
      setisEditQuickBatch(false);
      setShowCheckbox(true);
      setBatchKeyWordbox("");
      setBatchSizeBox("");
      setSummararizebatchbox(true);
      setEditSummary(false);
      setIsBatchOpen(false);
      setOpenRunStatus("");
      setSaveExecuteStatushandle(false);
      setQuickRunStatus(null);
      setLoaderwill(false);
      setcontinuesLoader(false);
      setTableFlutuationOff(false);
      setFileLoader(false);
      setDragDropfile("");
      setShowOutput(false);
      setQuickSaveExecuteResponse("");
      dispatch(quick_Action_Run_Status_Success(null));
      dispatch(Run_Quick_Action_Run_Id_Success(null));
      dispatch(quick_Action_Run_Save_Execute_Batch_Success(null));
      dispatch(quick_Action_Run_Generate_Chunks_Success(null));
    };

    // eslint-disable-next-line
  }, []);

  const [totalSDWordCount, setTotalSDWordCount] = useState(0);

  const [totalOFWordCount, setTotalOFWordCount] = useState(0);

  useEffect(() => {
    if (buildQuickActionDetaills) {
      let newTotalSDWordCount = 0;
      if (buildQuickActionDetaills?.supporting_documents) {
        buildQuickActionDetaills?.supporting_documents.map((data) => {
          newTotalSDWordCount += data?.supporting_document?.word_count ?? 0;
        });
        setTotalSDWordCount(newTotalSDWordCount);
      }
      let newTotalOFWordCount = 0;
      if (buildQuickActionDetaills?.output_formats) {
        buildQuickActionDetaills?.output_formats.map((data) => {
          newTotalOFWordCount += data?.output_format?.word_count ?? 0;
        });
        setTotalOFWordCount(newTotalOFWordCount);
      }
      setPageLoader(false);
    }

    // Open all Links of Desc in new tab
    const links = document.querySelectorAll(".description-card a");

    // Set target="_blank" for each anchor tag
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer"); // Security best practice
    });
  }, [buildQuickActionDetaills]);

  useEffect(() => {
    if (accessLevel === "") {
      setBatchProcessing("");
      setisEditQuickBatch(false);
      setShowCheckbox(true);
      setBatchKeyWordbox("");
      setBatchSizeBox("");
      setSummararizebatchbox(true);
      setEditSummary(false);
      setIsBatchOpen(false);
      setOpenRunStatus(null);
      setLoaderwill(false);
      setcontinuesLoader(false);
      setTableFlutuationOff(false);
      setDragDropfile("");
      setSaveExecuteStatushandle(false);
      setFileLoader(false);
      setQuickSaveExecuteResponse("");
      setShowOutput(false);
    }
  }, [accessLevel]);

  useEffect(() => {
    if (quickrunStatusData?.status) {
      setOpenRunStatus(quickrunStatusData);
    }
    if (quickrunStatusData?.result?.response || QuickSaveExecuteResponse) {
      setShowOutput(true);
    }
  }, [quickrunStatusData?.status]);

  useEffect(() => {
    if (quickrunStatusData?.status) {
      // setQuickRunStatus(quickrunStatusData?.status);
      setRunStatusMainData(quickrunStatusData);
    }

    if (quickrunStatusData?.execution_type === "SINGLE") {
      setBatchProcessing("SINGLE");
    }

    if (quickrunStatusData?.execution_type === "BATCH") {
      setIsBatchOpen(true);
      setPageLoader(false);
      setBatchProcessing("BATCHING");
    }
  }, [quickrunStatusData]);

  useEffect(() => {
    if (quickrunData?.error_type) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: quickrunData.error_message,
      });
    }
  }, [quickrunData?.error_type]);

  useEffect(() => {
    if (openRunStatus?.status === "FAILED") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: openRunStatus?.error_message,
      });
    }
  }, [openRunStatus?.status]);

  useEffect(() => {
    if (
      openRunStatus?.batch &&
      openRunStatus?.batch?.status &&
      saveExecuteStaushandle
    ) {
      if (
        openRunStatus?.batch?.status === "FAILED" &&
        openRunStatus?.batch?.error_message
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: openRunStatus && openRunStatus?.batch?.error_message,
        });
        // setIsBatchOpen(false);
        setcontinuesLoader(false);
        setTableFlutuationOff(false);
        setSaveExecuteStatushandle(false);
        // dispatch(quick_Action_Run_Status_Success(""));
      } else if (
        openRunStatus?.batch?.status === "CHUNKED" ||
        openRunStatus?.batch?.status === "COMPLETED"
      ) {
        setIsBatchOpen(false);
        setSaveExecuteStatushandle(false);
        dispatch(quick_Action_Run_Status_Success(""));
      } else if (
        openRunStatus?.batch?.status === "PROCESSING" ||
        (openRunStatus?.batch?.status === "VALIDATING" &&
          openRunStatus.status !== "BATCHING")
      ) {
        setTimeout(() => {
          dispatch(
            quick_Action_Run_Status_ActionHandler(
              params?.id,
              quickrunData?.action_run_id
            )
          );
        }, 3000);
      }
    } else if (
      openRunStatus?.status === "SUCCESS" ||
      openRunStatus?.status === "FAILED"
    ) {
      setPageLoader(false);
      setIsBatchOpen(false);
      setSaveExecuteStatushandle(false);
      dispatch(quick_Action_Run_Save_Execute_Batch_Success(null));
      setOpenRunStatus(null);
    } else if (
      openRunStatus?.status === "PROCESSING" ||
      openRunStatus?.status === "VALIDATING"
    ) {
      setTimeout(() => {
        dispatch(
          quick_Action_Run_Status_ActionHandler(
            params?.id,
            quickrunData?.action_run_id
          )
        );
      }, 3000);
    } else if (openRunStatus?.execution_type === "SINGLE") {
      setPageLoader(false);
    }
  }, [openRunStatus]);

  useEffect(() => {
    if (
      quickrunData?.status === "VALIDATING" &&
      quickrunData?.action_run_id &&
      openRunStatus?.status !== "BATCHING" &&
      openRunStatus?.status !== "SUCCESS"
    ) {
      setTimeout(() => {
        dispatch(
          quick_Action_Run_Status_ActionHandler(
            params?.id,
            quickrunData?.action_run_id
          )
        );
      }, 2000);
      setPageLoader(true);
    }
  }, [quickrunData?.status, quickrunData?.action_run_id]);

  const handleShowQuickSearch = () => {
    setShowQuickSearch(!showQuickSearch);
  };

  const batchOverlay = () => {
    setIsBatchOpen(!isBatchOpen);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      // setDragDropfile(files);
      setDragDropfile((prevFiles) => [...prevFiles, ...droppedFiles]);
      setIsUploadOutComputer(true);
      setPrivateData(true);
    }
    setRunStatusMainData("");
  };

  const handleUploadComputer = () => {
    setIsUploadOutComputer(true);
    setIsOwnOutData(false);
    setRunStatusMainData("");
    setTextAreaData("");
    setPrivateData(true);
  };

  const handleUploadOwnData = () => {
    setIsUploadOutComputer(false);
    setIsOwnOutData(true);
    setRunStatusMainData("");
    setPrivateData(true);
  };

  const isFileValidFile = (file) => {
    const fileName = file?.name?.toLowerCase();
    const allowedExtensions = [
      ".txt",
      ".doc",
      ".docx",
      ".pdf",
      ".mp3",
      ".mp4",
      ".m4a",
      ".jpeg",
      ".jpg",
      ".png",
      ".tiff",
      ".bmp",
      ".heif",
    ];

    const isValidExtension = allowedExtensions?.some((extension) =>
      fileName?.endsWith(extension)
    );

    return isValidExtension ? "file" : "text";
  };

  const [showAccessError, setShowAccessError] = useState(false);

  useEffect(() => {
    if (accessLevel) setShowAccessError(false);
  }, [accessLevel]);

  const handleActionClickApi = (is_batch) => {
    // setShowAccessError(!accessLevel ? true : false);

    // if (!accessLevel) {
    //   message.error("Please fill in all required fields");
    //   return;
    // }
    if (is_batch) setIsBatchOnLargeData(is_batch);

    if (datauploadComputer) {
      if (!datauploadComputer) {
        message.error("Please fill in all required fields");
        return;
      }
    }

    if (textAreaData) {
      if (!textAreaData) {
        message.error("Please fill in all required fields");
        return;
      }
    }
    const setid = datauploadComputer
      ? datauploadComputer?.map((item) => ({ id: item.id }))
      : "";
    // const setcontent = UploadEditData ? UploadEditData?.map((item) => ({ content: item.content })) : '';
    const setContent = datauploadComputer
      ? datauploadComputer?.map((item) => item.content).join(" ")
      : "";
    console.log(text, "text");
    const string =
      text &&
      text
        .map((text) => {
          if (text != null && text != undefined) {
            return text.replace(/<\/div>/g, "\n").replace(/<div[^>]*>/g, "");
          }
          return "";
        })
        .join(" ");
    let request = {
      prompt: !textAreaData ? string : textAreaData,
      prompt_type: isFileValidFile(getFileType || textAreaData),
      is_private: accessLevel === "ON" ? true : false,
      ...(!textAreaData && {
        files: setid,
      }),
      ...(ViewResult?.data && {
        quick_searches: [
          {
            supporting_document_id: SupportDocumentId,
            search_result: ViewResult.data.search_result,
          },
        ],
      }),
      is_batch: is_batch,
    };
    setPageLoader(true);
    dispatch(
      run_Quick_Action_Run_IdActionHandler(request, params?.id, setPageLoader)
    );
    setOpenRunStatus("");
    setisEditQuickBatch(false);
    setShowCheckbox(true);
    setBatchKeyWordbox("");
    setBatchSizeBox("");

    // gtm

    window.dataLayer.push({
      event: "Actions",
      buttonName: "Action button",
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
    });

    // clear
    dispatch(quick_Action_Run_Save_Execute_Batch_Success(null));
  };
  const handleOutPutListClick = (id) => {
    if (id) {
      const filteredResult = buildQuickActionDetaills?.output_formats.filter(
        (item) => item.output_format.id === id
      );
      seteditOutputData(filteredResult[0]?.output_format);
      setIsListOutputData(!isListOutputData);
    }
  };
  const handleSupportListClick = (id) => {
    if (id) {
      const filteredResult =
        buildQuickActionDetaills?.supporting_documents.filter(
          (item) => item.supporting_document.id === id
        );
      seteditOutputData(filteredResult[0]?.supporting_document);
      setIsListOutputData(!isListOutputData);
    }
  };

  const handleGoBackRun = () => {
    if (quickrunStatusData?.result?.response) {
      let navigateObj = {
        id: params?.id,
      };
      const queryParams = new URLSearchParams(navigateObj).toString();
      const queryParamsObject = Object.fromEntries(
        new URLSearchParams(queryParams)
      );
      Navigate(`/edit-quick-action/${queryParamsObject?.id}/`);
    } else {
      Navigate(-1);
    }
  };

  const setBackToWindow = () => {
    //quickrunStatusData?.result?.response || QuickSaveExecuteResponse
    if (showOutput) {
      dispatch(quick_Action_Run_Status_Success(null));
      setQuickSaveExecuteResponse(null);
      setShowOutput(false);
      setRunStatusMainData("");
      setDragDropfile("");
      setuploadDatarunAgain([]);
      dispatch(quick_Action_Run_Upload_File_With_Fileid_Success(null));
    } else {
      setIsUploadOutComputer(false);
      setPrivateData(false);
      setUploadComputerData([]);
    }
    setShowAccessError(false);
    setuploadDatarunAgain([]);

    setCoutingFiles(0);
    dispatch(quick_Action_Run_Save_Execute_Batch_Success(null));
    dispatch(quick_Action_Run_Upload_File_With_Fileid_Success(null));
  };

  useEffect(() => {
    if (
      (text && text.length > 0) ||
      (textAreaData && textAreaData.length > 0)
    ) {
      setIsActionBtnDisabled(false);
    } else {
      setIsActionBtnDisabled(true);
    }
  }, [text, textAreaData]);

  return (
    <>
      {pageLoader && <Loader />}
      <div className="run-quickaction-main">
        <div className="text-back">
          <h3>{buildQuickActionDetaills?.name}</h3>
          <div onClick={handleGoBackRun}>
            <MdKeyboardBackspace />
            Back
          </div>
        </div>
        <div className="run-quickaction-container">
          {!buildQuickActionDetaills?.is_restricted ? (
            <div>
              <Card className="run-quickaction_1">
                <h3> Reference data </h3>
                <p>Word Count: {totalSDWordCount?.toLocaleString()}</p>
                <div className="run-card-eye">
                  {buildQuickActionDetaills?.supporting_documents?.map(
                    (document, index) => (
                      <div key={index}>
                        <div>
                          <PiBookOpenText />
                          {document?.supporting_document?.name}
                        </div>
                        <div>
                          <MdOutlineRemoveRedEye
                            onClick={() =>
                              handleSupportListClick(
                                document.supporting_document.id
                              )
                            }
                          />
                          <IoSearch
                            onClick={() => {
                              handleShowQuickSearch();
                              setSupportDocumentId(
                                document?.supporting_document_id
                              );
                            }}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </Card>

              <Card className="run-quickaction_1">
                <h3> Output Format </h3>
                <p>Word Count: {totalOFWordCount?.toLocaleString()}</p>
                <div className="run-card-eye">
                  {buildQuickActionDetaills?.output_formats?.map(
                    (document, index) => (
                      <div key={index}>
                        <div>
                          <FaRegFileAlt />
                          {document?.output_format?.name}
                        </div>
                        <div>
                          <MdOutlineRemoveRedEye
                            onClick={() =>
                              handleOutPutListClick(document.output_format.id)
                            }
                          />
                          <IoSearch />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </Card>

              <Card className="run-quickaction_card2">
                <h3>Prompt</h3>
                <p>{buildQuickActionDetaills?.prompt}</p>
              </Card>
            </div>
          ) : (
            <div>
              <Card
                className="run-quickaction_1"
                style={{ height: "fit-content" }}
              >
                <div>
                  <button
                    className="output-button"
                    style={{
                      marginBottom: "20px",
                      padding: "5px 20px",
                      gap: "10px",
                      fontSize: "14px",
                    }}
                  >
                    <CiCircleInfo
                      style={{
                        color: "red",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    Restricted Access
                  </button>
                </div>
                The reference data and prompt for this QuickAction has been
                restricted and can not be viewed or edited.
                {/* This QuickAction has been created by{' '}
                                <span style={{ fontWeight: '600' }}>
                                    {buildQuickActionDetaills?.created_by_name}
                                </span>
                                . The view for reference data and prompt has
                                been restricted by the owner. For further
                                details, please contact{' '}
                                {buildQuickActionDetaills?.created_by_name}. */}
              </Card>
              {buildQuickActionDetaills?.description && (
                <Card
                  className="run-quickaction_1 description-card"
                  style={{ height: "fit-content" }}
                >
                  <div>
                    <h4 style={{ marginTop: 0 }}>Description</h4>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: buildQuickActionDetaills?.description,
                    }}
                  />
                </Card>
              )}
            </div>
          )}

          <Card className="run-quickaction_2">
            <div className="drag-zone-width">
              {(!runStatusMainData?.result && !isOwnOutData) ||
              !isUploadOutComputer ? (
                <div className="switch-toggle-upper">
                  <h3>Input data</h3>
                  <div>
                    {!runStatusMainData?.result ? (
                      <div>
                        {BatchProcessing !== "BATCHING" ? (
                          <div
                            className="input-batch-btn"
                            onClick={() => handleActionClickApi(true)}
                          >
                            <img
                              src="/images/arrowdirection.svg "
                              alt=""
                              className="input-batch-btn"
                            />
                            Batch your input
                            <div className="vl"></div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    <Switch
                      size="large"
                      className="switch-large"
                      checked={accessLevel === "ON"}
                      onChange={handleAccessLevelChange}
                    />
                    <Tooltip
                      placement="top"
                      title={tooltipContent}
                      overlayStyle={{
                        maxWidth: "900px",
                      }}
                    >
                      <span style={{ marginRight: "4px" }}>Private</span>
                      <MdInfoOutline />
                    </Tooltip>
                  </div>
                </div>
              ) : null}
              {isUploadOutComputer || DragDropfile ? (
                <UploadComputerData
                  back={setIsUploadOutComputer}
                  isUploadOutComputer={isUploadOutComputer}
                  params={params?.id}
                  setUploadComputerData={setUploadComputerData}
                  datauploadComputer={datauploadComputer}
                  setText={setText}
                  uploadFilebyidAgain={uploadFilebyidAgain}
                  setGetFileType={setGetFileType}
                  quickrunStatusData={runStatusMainData}
                  setuplpad={setRunStatusMainData}
                  setUploadEditData={setUploadEditData}
                  setAccessLevel={setAccessLevel}
                  QuickSaveExecuteResponse={QuickSaveExecuteResponse}
                  setQuickSaveExecuteResponse={setQuickSaveExecuteResponse}
                  fileLoader={fileLoader}
                  setFileLoader={setFileLoader}
                  DragDropfile={DragDropfile}
                  setDragDropfile={setDragDropfile}
                  setBack={setBackToWindow}
                  showOutput={showOutput}
                  setShowOutput={setShowOutput}
                  setBatchProcessing={setBatchProcessing}
                  setCoutingFiles={setCoutingFiles}
                  coutingFiles={coutingFiles}
                />
              ) : isOwnOutData ? (
                <UploadOwnData
                  back={setIsOwnOutData}
                  privateData={setPrivateData}
                  setTextAreaData={setTextAreaData}
                  quickrunStatusData={runStatusMainData}
                  setAccessLevel={setAccessLevel}
                  QuickSaveExecuteResponse={QuickSaveExecuteResponse}
                  setQuickSaveExecuteResponse={setQuickSaveExecuteResponse}
                  setShowAccessError={setShowAccessError}
                  setuplpad={setRunStatusMainData}
                  setShowOutput={setShowOutput}
                  setBatchProcessing={setBatchProcessing}
                  IsBatchOnLargeData={IsBatchOnLargeData}
                  params={params}
                />
              ) : (
                <div
                  className={`drag-drop-field supporting-document-out-2 ${
                    isDragging ? "dragging" : ""
                  }`}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <div className="drag-zone">
                    {/* <h3>Input data</h3> */}
                    <div className="supporting-document-out-upload-img-height-320">
                      <div className="supporting-document-out-upload-main-div">
                        <div className="supporting-document-out-upload-span">
                          <div className="supporting-document-out-upload-sub-div">
                            <div className="supporting-document-out-upload-middle-div-first-p run-quick-uploadtype">
                              {
                                "Drag & Drop Your file or click to upload your file (PDF, MP3, MP4, DOCX, DOC or txt files)"
                              }
                            </div>
                            <div className="supporting-document-out-upload-middle-div-second-p">
                              Or
                            </div>
                            <div className="supporting-document-out-upload-middle-div-tree-p">
                              <div
                                className="supporting-document-out-image-button"
                                onClick={handleUploadComputer}
                              >
                                <RiFileUploadFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />
                                Upload from Computer
                              </div>
                            </div>
                            <div className="supporting-document-out-upload-middle-div-tree-p">
                              <div
                                className="supporting-document-out-image-button"
                                onClick={handleUploadOwnData}
                              >
                                <RiEditBoxFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />
                                Enter Your Own Data
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  gap: "75px",
                  justifyContent: "center",
                }}
              >
                {/* {!runStatusMainData?.result ? (
                  <div>
                    {BatchProcessing !== "BATCHING" ? (
                      <Button
                        className="main-api input-batch-btn"
                        onClick={() => handleActionClickApi(true)}
                      >
                        <img src="/images/arrowdirection.png" alt="" />
                        Batch your input
                      </Button>
                    ) : null}
                  </div>
                ) : null} */}

                {!runStatusMainData?.result ? (
                  <div>
                    {BatchProcessing !== "BATCHING" ? (
                      <Button
                        className="main-api action-btn"
                        disabled={isActionBtnDisabled}
                        onClick={() => handleActionClickApi(false)}
                      >
                        Action
                      </Button>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </Card>
        </div>
      </div>
      {isListOutputData ? (
        <ReferencedataShow
          isListOutputData={isListOutputData}
          handleOutPutListClick={handleOutPutListClick}
          editOutputData={editOutputData}
        />
      ) : null}
      <Drawer
        placement="right"
        closable={false}
        onClose={batchOverlay}
        open={isBatchOpen}
        key="right"
        width={"40%"}
        maskClosable={false}
      >
        <img
          src={SideClose}
          alt=""
          onClick={batchOverlay}
          style={{ float: "right", cursor: "pointer", marginTop: 18 }}
        />

        <QuickBatchDrawer
          quickRunId={quickrunStatusData?.action_run_id}
          quickActionId={params?.id}
          BatchProcessing={BatchProcessing}
          batchOverlay={batchOverlay}
          statusData={quickrunStatusData}
          setQuickSaveExecuteResponse={setQuickSaveExecuteResponse}
          loader={quickrunStatusDataLoader}
          setisEditQuickBatch={setisEditQuickBatch}
          isEditQuickBatch={isEditQuickBatch}
          setShowCheckbox={setShowCheckbox}
          showCheckbox={showCheckbox}
          batchSizeBox={batchSizeBox}
          batchKeywordbox={batchKeywordbox}
          setBatchKeyWordbox={setBatchKeyWordbox}
          setBatchSizeBox={setBatchSizeBox}
          Summararizebatchbox={Summararizebatchbox}
          setSummararizebatchbox={setSummararizebatchbox}
          setEditSummary={setEditSummary}
          EditSummary={EditSummary}
          setSaveExecuteStatushandle={setSaveExecuteStatushandle}
          setcontinuesLoader={setcontinuesLoader}
          continuesLoader={continuesLoader}
          setIsBatchOpen={setIsBatchOpen}
          setTableFlutuationOff={setTableFlutuationOff}
          tableFlutuationOff={tableFlutuationOff}
          setLoaderwill={setLoaderwill}
          loaderwill={loaderwill}
          IsBatchOnLargeData={IsBatchOnLargeData}
        />
      </Drawer>
      {showQuickSearch ? (
        <QuickSearchRun
          handleShowQuickSearch={handleShowQuickSearch}
          showQuickSearch={showQuickSearch}
          ViewResult={ViewResult}
          setViewResult={setViewResult}
          getSupportingDocId={SupportDocumentId}
        />
      ) : null}
    </>
  );
};

export default RunQuickAction;
